export const wfBubble_41 = { 
    current : {
        backgroundColor: '#e31b22',
        borderColor: '#B5151B',
        color: 'white',
    }
}